export default [
    {
        bgColor: 'var(--blueBadgeBackground)',
        textColor: 'var(--blueBadgeColor)'
    },
    {
        bgColor: 'var(--greenBadgeBackground)',
        textColor: 'var(--greenBadgeColor)'
    },
    {
        bgColor: 'var(--orangeBadgeBackground)',
        textColor: 'var(--orangeBadgeColor)'
    },
    // {
    //     bgColor: '#f0ecf9',
    //     textColor: '#9578d3',
    // },
    {
        bgColor: 'var(--redBadgeBackground)',
        textColor: 'var(--redBadgeColor)'
    }
]
